/* tslint:disable */
/* eslint-disable */
/**
 * openapi
 * bales cloud
 *
 * The version of the OpenAPI document: 1.0
 * Contact: test@example.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { OpportunityStageMasterBody } from '../models';
// @ts-ignore
import { OpportunityStageMasters } from '../models';
// @ts-ignore
import { UpdateOpportunityStageMasterBody } from '../models';
/**
 * OpportunityStageMasterApi - axios parameter creator
 * @export
 */
export const OpportunityStageMasterApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 商談のステージマスター名削除API
         * @summary 商談のステージマスター名削除API
         * @param {number} id OpportunityStageMaster ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOpportunityStageMasters: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOpportunityStageMasters', 'id', id)
            const localVarPath = `/api/user/opportunity_stage_masters/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 商談のステージマスター名一覧取得API
         * @summary 商談のステージマスター名一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOpportunityStageMasters: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/opportunity_stage_masters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 商談のステージマスター名作成API
         * @summary 商談のステージマスター名作成API
         * @param {OpportunityStageMasterBody} [opportunityStageMasterBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postOpportunityStageMasters: async (opportunityStageMasterBody?: OpportunityStageMasterBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/opportunity_stage_masters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(opportunityStageMasterBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 商談のステージマスター名作成API
         * @summary 商談のステージマスター名作成API
         * @param {number} id OpportunityStageMaster ID
         * @param {UpdateOpportunityStageMasterBody} [updateOpportunityStageMasterBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putOpportunityStageMasters: async (id: number, updateOpportunityStageMasterBody?: UpdateOpportunityStageMasterBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('putOpportunityStageMasters', 'id', id)
            const localVarPath = `/api/user/opportunity_stage_masters/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateOpportunityStageMasterBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OpportunityStageMasterApi - functional programming interface
 * @export
 */
export const OpportunityStageMasterApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OpportunityStageMasterApiAxiosParamCreator(configuration)
    return {
        /**
         * 商談のステージマスター名削除API
         * @summary 商談のステージマスター名削除API
         * @param {number} id OpportunityStageMaster ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOpportunityStageMasters(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOpportunityStageMasters(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 商談のステージマスター名一覧取得API
         * @summary 商談のステージマスター名一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOpportunityStageMasters(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OpportunityStageMasters>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOpportunityStageMasters(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 商談のステージマスター名作成API
         * @summary 商談のステージマスター名作成API
         * @param {OpportunityStageMasterBody} [opportunityStageMasterBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postOpportunityStageMasters(opportunityStageMasterBody?: OpportunityStageMasterBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postOpportunityStageMasters(opportunityStageMasterBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 商談のステージマスター名作成API
         * @summary 商談のステージマスター名作成API
         * @param {number} id OpportunityStageMaster ID
         * @param {UpdateOpportunityStageMasterBody} [updateOpportunityStageMasterBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putOpportunityStageMasters(id: number, updateOpportunityStageMasterBody?: UpdateOpportunityStageMasterBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putOpportunityStageMasters(id, updateOpportunityStageMasterBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OpportunityStageMasterApi - factory interface
 * @export
 */
export const OpportunityStageMasterApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OpportunityStageMasterApiFp(configuration)
    return {
        /**
         * 商談のステージマスター名削除API
         * @summary 商談のステージマスター名削除API
         * @param {number} id OpportunityStageMaster ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOpportunityStageMasters(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.deleteOpportunityStageMasters(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 商談のステージマスター名一覧取得API
         * @summary 商談のステージマスター名一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOpportunityStageMasters(options?: any): AxiosPromise<Array<OpportunityStageMasters>> {
            return localVarFp.getOpportunityStageMasters(options).then((request) => request(axios, basePath));
        },
        /**
         * 商談のステージマスター名作成API
         * @summary 商談のステージマスター名作成API
         * @param {OpportunityStageMasterBody} [opportunityStageMasterBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postOpportunityStageMasters(opportunityStageMasterBody?: OpportunityStageMasterBody, options?: any): AxiosPromise<void> {
            return localVarFp.postOpportunityStageMasters(opportunityStageMasterBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 商談のステージマスター名作成API
         * @summary 商談のステージマスター名作成API
         * @param {number} id OpportunityStageMaster ID
         * @param {UpdateOpportunityStageMasterBody} [updateOpportunityStageMasterBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putOpportunityStageMasters(id: number, updateOpportunityStageMasterBody?: UpdateOpportunityStageMasterBody, options?: any): AxiosPromise<void> {
            return localVarFp.putOpportunityStageMasters(id, updateOpportunityStageMasterBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OpportunityStageMasterApi - interface
 * @export
 * @interface OpportunityStageMasterApi
 */
export interface OpportunityStageMasterApiInterface {
    /**
     * 商談のステージマスター名削除API
     * @summary 商談のステージマスター名削除API
     * @param {number} id OpportunityStageMaster ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpportunityStageMasterApiInterface
     */
    deleteOpportunityStageMasters(id: number, options?: AxiosRequestConfig): AxiosPromise<void>;

    /**
     * 商談のステージマスター名一覧取得API
     * @summary 商談のステージマスター名一覧取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpportunityStageMasterApiInterface
     */
    getOpportunityStageMasters(options?: AxiosRequestConfig): AxiosPromise<Array<OpportunityStageMasters>>;

    /**
     * 商談のステージマスター名作成API
     * @summary 商談のステージマスター名作成API
     * @param {OpportunityStageMasterBody} [opportunityStageMasterBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpportunityStageMasterApiInterface
     */
    postOpportunityStageMasters(opportunityStageMasterBody?: OpportunityStageMasterBody, options?: AxiosRequestConfig): AxiosPromise<void>;

    /**
     * 商談のステージマスター名作成API
     * @summary 商談のステージマスター名作成API
     * @param {number} id OpportunityStageMaster ID
     * @param {UpdateOpportunityStageMasterBody} [updateOpportunityStageMasterBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpportunityStageMasterApiInterface
     */
    putOpportunityStageMasters(id: number, updateOpportunityStageMasterBody?: UpdateOpportunityStageMasterBody, options?: AxiosRequestConfig): AxiosPromise<void>;

}

/**
 * Request parameters for deleteOpportunityStageMasters operation in OpportunityStageMasterApi.
 * @export
 * @interface OpportunityStageMasterApiDeleteOpportunityStageMastersRequest
 */
export interface OpportunityStageMasterApiDeleteOpportunityStageMastersRequest {
    /**
     * OpportunityStageMaster ID
     * @type {number}
     * @memberof OpportunityStageMasterApiDeleteOpportunityStageMasters
     */
    readonly id: number
}

/**
 * Request parameters for postOpportunityStageMasters operation in OpportunityStageMasterApi.
 * @export
 * @interface OpportunityStageMasterApiPostOpportunityStageMastersRequest
 */
export interface OpportunityStageMasterApiPostOpportunityStageMastersRequest {
    /**
     * 
     * @type {OpportunityStageMasterBody}
     * @memberof OpportunityStageMasterApiPostOpportunityStageMasters
     */
    readonly opportunityStageMasterBody?: OpportunityStageMasterBody
}

/**
 * Request parameters for putOpportunityStageMasters operation in OpportunityStageMasterApi.
 * @export
 * @interface OpportunityStageMasterApiPutOpportunityStageMastersRequest
 */
export interface OpportunityStageMasterApiPutOpportunityStageMastersRequest {
    /**
     * OpportunityStageMaster ID
     * @type {number}
     * @memberof OpportunityStageMasterApiPutOpportunityStageMasters
     */
    readonly id: number

    /**
     * 
     * @type {UpdateOpportunityStageMasterBody}
     * @memberof OpportunityStageMasterApiPutOpportunityStageMasters
     */
    readonly updateOpportunityStageMasterBody?: UpdateOpportunityStageMasterBody
}

/**
 * OpportunityStageMasterApi - object-oriented interface
 * @export
 * @class OpportunityStageMasterApi
 * @extends {BaseAPI}
 */
export class OpportunityStageMasterApi extends BaseAPI implements OpportunityStageMasterApiInterface {
    /**
     * 商談のステージマスター名削除API
     * @summary 商談のステージマスター名削除API
     * @param {OpportunityStageMasterApiDeleteOpportunityStageMastersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpportunityStageMasterApi
     */
    public deleteOpportunityStageMasters(requestParameters: OpportunityStageMasterApiDeleteOpportunityStageMastersRequest, options?: AxiosRequestConfig) {
        return OpportunityStageMasterApiFp(this.configuration).deleteOpportunityStageMasters(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 商談のステージマスター名一覧取得API
     * @summary 商談のステージマスター名一覧取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpportunityStageMasterApi
     */
    public getOpportunityStageMasters(options?: AxiosRequestConfig) {
        return OpportunityStageMasterApiFp(this.configuration).getOpportunityStageMasters(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 商談のステージマスター名作成API
     * @summary 商談のステージマスター名作成API
     * @param {OpportunityStageMasterApiPostOpportunityStageMastersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpportunityStageMasterApi
     */
    public postOpportunityStageMasters(requestParameters: OpportunityStageMasterApiPostOpportunityStageMastersRequest = {}, options?: AxiosRequestConfig) {
        return OpportunityStageMasterApiFp(this.configuration).postOpportunityStageMasters(requestParameters.opportunityStageMasterBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 商談のステージマスター名作成API
     * @summary 商談のステージマスター名作成API
     * @param {OpportunityStageMasterApiPutOpportunityStageMastersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpportunityStageMasterApi
     */
    public putOpportunityStageMasters(requestParameters: OpportunityStageMasterApiPutOpportunityStageMastersRequest, options?: AxiosRequestConfig) {
        return OpportunityStageMasterApiFp(this.configuration).putOpportunityStageMasters(requestParameters.id, requestParameters.updateOpportunityStageMasterBody, options).then((request) => request(this.axios, this.basePath));
    }
}
